(() => {
  if (window.bsFocusPlansInitialized) return;
  window.bsFocusPlansInitialized = true;

  const init = (section) => {
    if (section.dataset.bsFocusReady) return;
    const tablist = section.querySelector('[data-bs-focus-tabs]');
    const tabs = Array.from(section.querySelectorAll('[data-bs-focus-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-bs-focus-panel]'));
    if (!tablist || !tabs.length || tabs.length !== panels.length) return;
    section.dataset.bsFocusReady = 'true';
    tablist.setAttribute('role', 'tablist');

    const activate = (index, moveFocus = false) => {
      tabs.forEach((tab, current) => {
        const selected = current === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        panels[current].hidden = !selected;
      });
      if (moveFocus) tabs[index].focus();
    };

    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      panels[index].tabIndex = 0;
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(next, true);
      });
    });
    activate(0);
    tablist.hidden = false;
    section.addEventListener('shopify:block:select', (event) => {
      const index = panels.findIndex((panel) => panel.dataset.bsFocusBlock === event.detail.blockId);
      if (index !== -1) activate(index);
    });
  };

  const initWithin = (root) => {
    if (root.matches?.('[data-bs-focus]')) init(root);
    root.querySelectorAll('[data-bs-focus]').forEach(init);
  };
  initWithin(document);
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();
